import {
    AfterViewChecked,
    Component,
    DoCheck,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output
} from '@angular/core';

@Component({
    selector: 'odd-input-tag',
    templateUrl: './input-tag.component.html',
    styleUrls: [ './input-tag.component.scss' ],
})

export class InputTagComponent implements OnInit, AfterViewChecked, DoCheck {
    @Input() public value: string[] = [];
    @Input() public readonly size: string;
    @Input() public readonly placeholder: string = '';
    @Input('checkData') public readonly fireCheckData: (data: string) => boolean = () => true;

    @Output('onChange') public readonly fireChange: EventEmitter<string[]> = new EventEmitter<string[]>();

    constructor(
        private readonly element: ElementRef,
        @Inject('window') private readonly window,
    ) {}

    public ngOnInit(): void {
        setTimeout(() => this.window.bulmaTagsinput.attach(), 500);
    }

    public ngDoCheck(): void {
        this.value = [];
        const tagInputElement = this.element.nativeElement.firstChild;

        if (tagInputElement && tagInputElement.childNodes[1] && tagInputElement.childNodes[1].childNodes.length > 1) {
            for (const node of tagInputElement.childNodes[1].childNodes) {
                if (node.className === 'control') {
                    if (this.value.indexOf(node.dataset.tag) < 0 && this.fireCheckData(node.dataset.tag)) {
                        this.value.push(node.dataset.tag);
                    } else {
                        node.remove();
                    }
                }
            }

            this.fireChange.emit(this.value);
        }
    }

    public ngAfterViewChecked(): void {
        const tagInputElement = this.element.nativeElement.firstChild.childNodes[1];

        if (tagInputElement) {
            this.addClass(tagInputElement, this.size);
        }
    }

    private addClass = (element: any, clazz: string) => {
        element.classList.remove(clazz);
        element.classList.add(clazz);
    }
}
